// LaunchDarkly flag keys for Crop Season Service V2 migration
export const CROP_SEASON_FETCH_V2 = 'releaseBeCropSeasonFetchV2';
export const CROP_SEASON_FETCH_V2_BY_ORG = 'releaseBeCropSeasonFetchV2ByOrg';
export const CROP_SEASON_CREATE_V2 = 'releaseBeCropSeasonCreateV2';
export const CROP_SEASON_CREATE_V2_BY_ORG = 'releaseBeCropSeasonCreateV2ByOrg';
export const CROP_SEASON_UPDATE_V2 = 'releaseBeCropSeasonUpdateV2';
export const CROP_SEASON_UPDATE_V2_BY_ORG = 'releaseBeCropSeasonUpdateV2ByOrg';
export const CROP_SEASON_DELETE_V2 = 'releaseBeCropSeasonDeleteV2';
export const CROP_SEASON_DELETE_V2_BY_ORG = 'releaseBeCropSeasonDeleteV2ByOrg';
export const CROP_SEASONS_LIST_V2 = 'releaseBeCropSeasonsListV2';
export const CROP_SEASONS_LIST_V2_BY_ORG = 'releaseBeCropSeasonsListV2ByOrg';
export const CROP_SEASONS_CONDENSED_V2 = 'releaseBeCropSeasonsCondensedV2';
export const CROP_SEASONS_CONDENSED_V2_BY_ORG =
  'releaseBeCropSeasonsCondensedV2ByOrg';
